import { Link, useLocation } from 'react-router-dom';

export function NotFoundView() {
  const location = useLocation();
  const attempted = `${location.pathname}${location.search}${location.hash}`;

  return (
    <div className="flex h-full w-full items-center justify-center p-8" data-testid="route-not-found">
      <div className="max-w-lg text-center">
        <p className="text-sm font-medium text-muted-foreground">404</p>
        <h1 className="mt-2 text-2xl font-semibold">This page does not exist</h1>
        <p className="mt-4 text-sm text-muted-foreground">
          Nothing is routed at{' '}
          <code
            className="rounded bg-muted px-1.5 py-0.5 font-mono text-foreground"
            data-testid="route-not-found-path"
          >
            {attempted}
          </code>
          .
        </p>
        <Link
          to="/chat"
          className="mt-6 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          data-testid="route-not-found-chat-link"
        >
          Go to Chat
        </Link>
      </div>
    </div>
  );
}
